import { useEffect, useState } from 'react';

const getStorageValue = <V>(key: string, defaultValue: V) => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem(key);
    const initial = saved !== null ? JSON.parse(saved) : defaultValue;
    return initial ?? defaultValue;
  }
};

const useLocalStorage = <V>(key: string, defaultValue: V = null) => {
  const [value, setValue] = useState(getStorageValue<V>(key, defaultValue));

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return [value, setValue];
};

export default useLocalStorage;
